import { setStatusBarColor } from '../../../backbone-unorganized/utils/setStatusBarColor';
import { BaseToolbarNavPageLayout } from './baseLayoutViews';
import { confirmNotification } from '../../../shared/utils/notifications';

/**
 * Image previewer for our forms, previous submissions, tasks, and title images.
 * @param  {string}         src             The image source. If not provided, will use target 'src' attribute
 * @return {boolean}        allow_delete    If true, will show a delete button on the previewer. target and model are required for this to be true.
 * @param  {jQuery Obj}     target          The target element (icon) that was clicked to show this modal. This is required if allow_delete is true
 * @return {Backbone.Model} model           The model for the form field. This is required if allow_delete is true.
 */
export const ImagePreviewModal = BaseToolbarNavPageLayout.extend({
    template: '#tpl_image_preview_dialog',
    is_modal: true,

    src: null,
    allow_delete: true,

    templateHelpers: function () {
        return {
            src: this.src,
            allow_delete: this.allow_delete
        };
    },

    events: {
        'click .delete_image': 'remove_image'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        if (!this.src) {
            throw new Error('Programmer Error: no src set for ImagePreviewModal');
        }

        setStatusBarColor();
    },

    onRender: function () {
        this.$el.addClass('image_preview_modal');
        this.on_orientation_change();

        var $image_preview = this.$el.find('#image_preview');
        var $loading_circle = this.$el.find('.loading_spinner');
        var $loading_failed = this.$el.find('.preview_failed');

        // hide preview until it's ready
        $image_preview.css('opacity', 0);
        $loading_circle.show();

        var high_res = $f.storage.get_high_res_url_from_thumbnail(this.src, 234);
        var tmp_load_img = $(`<img src="${high_res}" />`);

        // When the full res image has loaded, show it instead of the thumbnail
        var this_ = this;
        tmp_load_img.on('load', function () {
            $image_preview.attr('src', high_res);

            this_.on_orientation_change();
            $loading_circle.hide();

            $image_preview.velocity(
                {
                    opacity: 1
                },
                300,
                function () {
                    // Now that the image has loaded, all the user to pinch-to-zoom:
                    this_.enable_pinch_to_zoom($image_preview);
                    this_.on_orientation_change();
                }
            );
        });

        tmp_load_img.on('error', function () {
            $loading_circle.hide();
            $loading_failed.velocity('fadeIn');
        });
    },

    /**
     * Vertically center the image.
     */
    on_orientation_change: function () {
        ImagePreviewModal.__super__.on_orientation_change.apply(this, arguments);

        var $image_preview = this.$el.find('#image_preview');
        $image_preview.css('margin', `-${$image_preview.height() / 2}px auto 0 auto`);
    },

    on_click_delete: function () {
        throw new Error('Programmer Error: on_click_delete() not implemented in ImagePreviewModal');
    },

    remove_image: function () {
        var this_ = this;

        confirmNotification(_t('mobile_message_image_confirm_remove_image'), function (is_success) {
            if (!is_success) {
                return;
            }

            this_.on_click_delete();
            this_.close();
        });

        return false;
    },

    /**
     * Uses HammerJS and touch events to enable pinch-to-zoom. It also allows zooming
     * with double-tap.
     *
     * Works on Android 4.0+
     *
     * @see http://stackoverflow.com/a/27572427/477632
     * @param  {DOM element}    elm    The DOM element (or jQuery object) of the image to make zoommable
     */
    enable_pinch_to_zoom: function (elm) {
        if (elm instanceof jQuery) {
            elm = elm.get(0);
        }

        var hammertime = new Hammer(elm, {});
        hammertime.get('pinch').set({
            enable: true
        });

        var posX = 0,
            posY = 0,
            scale = 1,
            last_scale = 1,
            last_posX = 0,
            last_posY = 0,
            max_pos_x = 0,
            max_pos_y = 0,
            transform = '',
            el = elm;

        hammertime.on('doubletap pan pinch panend pinchend', function (ev) {
            if (ev.type == 'doubletap') {
                transform = 'translate3d(0, 0, 0) scale3d(2, 2, 1) ';
                scale = 2;
                last_scale = 2;
                try {
                    if (
                        window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() !=
                        'matrix(1, 0, 0, 1, 0, 0)'
                    ) {
                        transform = 'translate3d(0, 0, 0) scale3d(1, 1, 1) ';
                        scale = 1;
                        last_scale = 1;
                    }
                } catch (err) {
                    // if we fail, keep original values
                }
                el.style.webkitTransform = transform;
                transform = '';
            }

            // pan
            if (scale != 1) {
                posX = last_posX + ev.deltaX;
                posY = last_posY + ev.deltaY;
                max_pos_x = Math.ceil(((scale - 1) * el.clientWidth) / 2);
                max_pos_y = Math.ceil(((scale - 1) * el.clientHeight) / 2);
                if (posX > max_pos_x) {
                    posX = max_pos_x;
                }
                if (posX < -max_pos_x) {
                    posX = -max_pos_x;
                }
                if (posY > max_pos_y) {
                    posY = max_pos_y;
                }
                if (posY < -max_pos_y) {
                    posY = -max_pos_y;
                }
            }

            // pinch
            if (ev.type == 'pinch') {
                scale = Math.max(0.999, Math.min(last_scale * ev.scale, 4));
            }
            if (ev.type == 'pinchend') {
                last_scale = scale;
            }

            // panend
            if (ev.type == 'panend') {
                last_posX = posX < max_pos_x ? posX : max_pos_x;
                last_posY = posY < max_pos_y ? posY : max_pos_y;
            }

            if (scale != 1) {
                transform =
                    'translate3d(' + posX + 'px,' + posY + 'px, 0) ' + 'scale3d(' + scale + ', ' + scale + ', 1)';
            }

            if (transform) {
                el.style.webkitTransform = transform;
            }
        });
    },

    close: function () {
        // extend close() instead of using onClose() so that $f.mobile.nav() is called first
        ImagePreviewModal.__super__.close.apply(this, arguments);
        setStatusBarColor();
    }
});
